import { $streemApiV1 } from "shared/boot/api";

import type { RecentSearch } from "./types";

export async function deleteRecentSearch(id: number): Promise<void> {
  await $streemApiV1.delete(`universal_searches/${id}`);
}

export async function getRecentSearches(
  query?: string
): Promise<RecentSearch[]> {
  const { data } = await $streemApiV1.get<RecentSearch[]>(
    "universal_searches",
    {
      params: { ...(query && { q: query }) },
    }
  );

  return data;
}
